export default __webpack_public_path__ + "static/media/Camerron-5.7568792f.png";